import { useState, useEffect } from 'react';
import { api } from '../services/api';
import './DashboardPage.css';

export default function DashboardPage() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/dashboard/stats').then(setStats).catch(() => {});
  }, []);

  const fmt = n => (n == null ? '—' : String(n));
  const fmtMrr = n => (n == null ? '—' : `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 0 })}`);

  const cards = [
    { label: 'Active Clients',  value: fmt(stats?.activeClients) },
    { label: 'Open Contracts',  value: fmt(stats?.openContracts) },
    { label: 'Unpaid Invoices', value: fmt(stats?.unpaidInvoices) },
    { label: 'MRR',             value: fmtMrr(stats?.mrr) },
  ];

  return (
    <div className="dashboard">
      <div className="stat-grid">
        {cards.map(({ label, value }) => (
          <div key={label} className="stat-card">
            <span className="stat-value">{value}</span>
            <span className="stat-label">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
